/**
 * Hands the stores register to the executive Logistics board.
 *
 * Renders nothing, and sits in the shell for the life of the session. Unlike
 * `PlatformFeed` it runs under BOTH adapters, because the register it feeds is
 * held here either way — on the platform in its stores register, or as a note
 * where it holds none yet; on the mock as the sample estate — and the Logistics board has been drawing "awaiting the stores
 * system" in both.
 *
 * It never causes the demo chunk to load: the feed is queued through
 * `whenDemoLoaded`, so a session that never opens a board never downloads one.
 */
import { useEffect } from "react";
import { useSession } from "../../app/SessionContext";
import { whenDemoLoaded } from "../../demo/domain/load";
import { startingStores, useStoresRead } from "./useStores";

export function StoresFeed() {
  /* the same register the desk reads — the platform's where it holds one, else the note — so the two cannot disagree */
  const { register, settled } = useStoresRead();
  /* build 7: on the live platform nothing entered is an empty store, never the sample's stock */
  const platform = useSession().source.kind === "platform";

  useEffect(() => {
    if (!settled) return;
    const held = register ?? startingStores(platform);
    whenDemoLoaded(() => {
      void import("../../domain/storesFeed").then((m) => m.feedInventory(held, new Date()));
    });
  }, [settled, register, platform]);

  return null;
}
